import React from 'react';
import { SWORN_DATA } from '../../gameData';
import { FaeKey } from '../../types';

// Memoize regexes to avoid recompiling on every render
const regexCache = new Map<string, RegExp>();

export const highlightKeywords = (description: string, faeKey: FaeKey): React.ReactNode[] => {
  const fae = SWORN_DATA.fae_lords[faeKey];
  const rgb = fae.color_scheme?.highlight_text;
  const highlightColor = rgb ? `rgb(${rgb.R}, ${rgb.G}, ${rgb.B})` : '#e6a84f';

  const escapeRegExp = (string: string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const cacheKey = faeKey;
  let pattern = regexCache.get(cacheKey);
  
  if (!pattern && fae.keywords && fae.keywords.length > 0) {
      // Sort keywords by length (descending) to match longest phrases first
      const sortedKeywords = [...fae.keywords].sort((a, b) => b.length - a.length);
      const joinedPatterns = sortedKeywords.map(escapeRegExp).join('|');
      
      pattern = new RegExp(`(${joinedPatterns})`, 'gi');
      regexCache.set(cacheKey, pattern);
  }

  if (!pattern) {
      return [<span key="0" className="text-slate-200">{description}</span>];
  }

  const parts = description.split(pattern);

  return parts.map((part, i) => {
    if (!part) return null;
    
    const lowerPart = part.toLowerCase();
    const isKeyword = fae.keywords?.some(k => k.toLowerCase() === lowerPart);

    if (isKeyword) {
        return (
            <span key={i} style={{ color: highlightColor, fontWeight: 500 }}>
                {part}
            </span>
        );
    }
    
    return (
        <span key={i} className="text-slate-200">
            {part}
        </span>
    );
  });
};
